import React from 'react';
import ProductionAddEditModal from './production-add-edit';

import { MODAL_TYPES } from 'Feature/components/app-modals';

const { PRODUCTION_ADD_EDIT } = MODAL_TYPES;

const ProductionModals = () => {
  return (
    <>
      <ProductionAddEditModal modalId={PRODUCTION_ADD_EDIT} />
    </>
  );
};

export default ProductionModals;
